import { render } from "./DownloadChongya.vue?vue&type=template&id=e4b7da62&scoped=true"
import script from "./DownloadChongya.vue?vue&type=script&lang=js"
export * from "./DownloadChongya.vue?vue&type=script&lang=js"

import "./DownloadChongya.vue?vue&type=style&index=0&id=e4b7da62&scoped=true&lang=css"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4b7da62"]])

export default __exports__